/* Devices page (main-devices): concern filter from ?concern=<key> (T50) and the sideways comparison table (T49). */
(function () {
  var cfgEl = document.getElementById('dv-cfg');
  var hero = document.querySelector('[data-dv-hero]');
  var grid = document.querySelector('[data-dv-grid]');
  var tbl = document.querySelector('.dv-tbl');
  var x = document.querySelector('.dv-x');
  var hint = document.querySelector('.dv-hint');
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  // comparison: shadow on the sticky label column once scrolled, swipe hint only when the table is wider than the screen
  if (x) {
    var sc = function () {
      x.classList.toggle('sc', x.scrollLeft > 2);
      if (hint) hint.hidden = x.scrollWidth <= x.clientWidth + 2;
    };
    x.addEventListener('scroll', sc, { passive: true });
    window.addEventListener('resize', sc);
    sc();
  }

  if (!cfgEl || !hero || !grid) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var C = cfg.c || {};
  var eb = hero.querySelector('.eyebrow'), h1 = hero.querySelector('h1'), rs = hero.querySelector('.dv-reset');
  var orig = { eb: eb.innerHTML, h1: h1.innerHTML };
  var cards = grid.querySelectorAll('article.dcard[data-dev]');
  var ids = [];
  if (tbl) each(tbl.querySelectorAll('thead th[data-dev]'), function (th) { ids.push(th.getAttribute('data-dev')); });

  function order(list) {
    each(tbl.rows, function (tr) {
      var m = {};
      each(tr.querySelectorAll('[data-dev]'), function (c) { m[c.getAttribute('data-dev')] = c; });
      list.forEach(function (id) { if (m[id]) tr.appendChild(m[id]); });
    });
  }

  function apply(c) {
    var on = c ? c.d : [];
    if (c) { eb.textContent = cfg.eyebrow; h1.textContent = c.t; } else { eb.innerHTML = orig.eb; h1.innerHTML = orig.h1; }
    each(cards, function (el) {
      var i = on.indexOf(el.getAttribute('data-dev'));
      el.hidden = !!c && i < 0;
      el.style.order = c && i >= 0 ? String(i) : '';
    });
    if (c) grid.setAttribute('data-n', String(on.length)); else grid.removeAttribute('data-n');
    if (tbl) {
      order(c ? on.concat(ids.filter(function (id) { return on.indexOf(id) < 0; })) : ids);
      tbl.classList.toggle('f', !!c);
      each(tbl.querySelectorAll('[data-dev]'), function (el) { el.classList.toggle('on', on.indexOf(el.getAttribute('data-dev')) >= 0); });
      if (x) x.scrollLeft = 0;
    }
    if (rs) rs.hidden = !c;
  }

  var key = '';
  try { key = (new URLSearchParams(location.search).get('concern') || '').trim().toLowerCase(); } catch (e) {}
  var cur = Object.prototype.hasOwnProperty.call(C, key) ? C[key] : null;
  if (cur) {
    apply(cur);
    // the grid got shorter: land on the comparison again for ?concern=<key>#compare
    if (location.hash === '#compare') {
      var t = document.getElementById('compare');
      if (t) requestAnimationFrame(function () { t.scrollIntoView(); });
    }
  }

  if (rs) rs.querySelector('a').addEventListener('click', function (e) {
    e.preventDefault();
    try {
      var u = new URL(location.href);
      u.searchParams.delete('concern');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (err) {}
    apply(null);
    h1.setAttribute('tabindex', '-1');
    h1.focus({ preventScroll: true });
  });
})();
